import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldExclamationIcon } from '../icons';

const Unauthorized = () => (
  <div className="min-h-screen bg-legal-50 flex items-center justify-center px-4">
    <div className="max-w-md w-full bg-white border border-legal-200 rounded-xl p-8 text-center shadow-sm">
      <ShieldExclamationIcon className="h-12 w-12 text-red-500 mx-auto mb-4" />
      <h1 className="text-2xl font-bold text-legal-900 mb-2">Access denied</h1>
      <p className="text-legal-600 mb-6">
        You do not have permission to view this page. Contact your court administrator if
        you believe this is an error.
      </p>
      <Link
        to="/dashboard"
        className="inline-flex items-center px-4 py-2 bg-court-600 text-white rounded-lg hover:bg-court-700 text-sm"
      >
        Back to Dashboard
      </Link>
    </div>
  </div>
);

export default Unauthorized;
